import React from 'react';
import ExploreIcon from '@mui/icons-material/Explore';
import { motion } from 'framer-motion';
import setup from '../assets/data/setup.json';
import MotionSection from './ui/MotionSection';
import SectionHeader from './ui/SectionHeader';

function CurrentlyExploring() {
  return (
    <MotionSection id="exploring" muted>
      <SectionHeader
        eyebrow="Growth"
        title="What I'm Exploring Now"
        subtitle="Technologies and domains I'm actively learning—signals where I'm headed next."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {setup.currentlyExploring.map((item, index) => (
          <motion.div
            key={item}
            initial={{ opacity: 0, y: 10, filter: 'blur(4px)' }}
            whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: index * 0.04 }}
            whileHover={{ y: -2 }}
            className="ui-card ui-card-lift flex items-center gap-3 px-4 py-3.5"
          >
            <ExploreIcon sx={{ fontSize: 18 }} className="text-accent flex-shrink-0" />
            <span className="text-sm font-medium text-ink-secondary">{item}</span>
          </motion.div>
        ))}
      </div>
    </MotionSection>
  );
}

export default CurrentlyExploring;
